let _Vue;

function install(Vue) {
  if (install.installed && _Vue === Vue) return;
  install.installed = true;

  _Vue = Vue;

  Vue.directive("visible", {
    inserted: (el, binding, vnode) => {
      let value = binding.value;
      value = typeof value === "number" ? value + "" : visible;
      const allHidedenModules = window.hiddenModule;
      // 根据测试后续遇到情况做容错处理
      // const allHidedenModules = ["1","2","3","4",'5'];
      if (allHidedenModules) {
        // 如果传入字符串包含在 allHidedenModules 中则移除改元素
        if (allHidedenModules.indexOf(value) > -1) {
          if (el.parentNode) {
            el.parentNode.removeChild(el);
          }
        }
      }
    }
  });
}

export default install;



// WEBPACK FOOTER //
// ./src/directive/index.js